import { DataConfig } from "@/components/table/useDefaultDataConfig";
import { generateParams } from "@/utils/helper/generateParams";
import { axiosInstance } from "@/utils/lib/axios";
import { useMutation } from "@tanstack/react-query";

async function waitForMediaCompletion(
  url: string,
  interval = 2000,
): Promise<{ status: string; path?: string; originalFileName?: string }> {
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const {
      data: {
        data: { status, path, originalFileName },
      },
    } = await axiosInstance.get(`${url}`);

    if (status === "SUCCESS" || status === "ERROR" || status === "FAILED") {
      return {
        status,
        path,
        originalFileName: originalFileName ?? "list-trackerdata-apd.xlsx",
      };
    }

    await new Promise((resolve) => setTimeout(resolve, interval));
  }
}

async function exportDashboardRFS(
  config: DataConfig = {},
  isDownload: boolean = false,
  onDownload: boolean = false,
): Promise<{ status: string; fileName?: string }> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let createResponse: any = {};
  if (!isDownload) {
    createResponse = await axiosInstance.post(
      `/bpmn/Rfs/dashboard/export${generateParams(config)}`,
    );
    localStorage.setItem("isDownloadDashboardRFS", new Date().toISOString());
  }

  const downloadParams = {
    className: "com.alurkerja.rfs",
    entityId: config.entityId,
  };
  const { status, path, originalFileName } = await waitForMediaCompletion(
    !isDownload
      ? `/api/crud/media/${createResponse.data.data.id}`
      : `/api/crud/media/last${generateParams(downloadParams)}`,
  );

  if (onDownload && status === "SUCCESS") {
    const downloadResponse = await axiosInstance.get(
      "/api/crud/media/download",
      {
        params: { path, fileName: originalFileName, entityId: config.entityId },
        responseType: "blob",
      },
    );

    downloadFile(new Blob([downloadResponse.data]), originalFileName);
    localStorage.removeItem("isDownloadDashboardRFS");
    return { status: "IDLE" };
  } else {
    return { status };
  }
}

function downloadFile(blobData: Blob, fileName: string | undefined): void {
  const url = window.URL.createObjectURL(blobData);
  const link = document.createElement("a");
  link.href = url;
  if (typeof fileName === "string") {
    link.setAttribute("download", fileName);
  }
  document.body.appendChild(link);
  link.click();
  link.remove();
}

function useExportDashboardRFS() {
  return useMutation({
    mutationFn: async ({
      config,
      isDownload,
      onDownload,
    }: {
      config?: DataConfig;
      isDownload?: boolean;
      onDownload?: boolean;
    }) => {
      return await exportDashboardRFS(config, isDownload, onDownload);
    },
  });
}

export { useExportDashboardRFS };
